// src/components/mobile-app-download-button/mobile-app-download-button.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment SecondaryButtonFragment on UISecondaryButton {\n    __typename\n    primary\n    icon {\n      id\n      title\n      description\n    }\n    analytics {\n      linkName\n      referrerId\n      eventType\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  query MobileAppDownloadButtonQuery($context: ContextInput!, $optionalPageId: String) {\n    notification(context: $context) {\n      mobileAppDownloadButton(optionalPageId: $optionalPageId) {\n        button {\n          ...SecondaryButtonFragment\n        }\n        revealAction {\n          event\n          referrerId\n          linkName\n        }\n        action {\n          ... on UIBannerLinkAction {\n            target\n            resource {\n              value\n            }\n          }\n          ... on UINotificationAction {\n            notificationSlot\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import React2 from "react";
import { useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/mobile-app-download-button-secondary-button/mobile-app-download-button-secondary-button.tsx
import React from "react";
import { useLocation } from "react-router-dom-v5-compat";
import { gql } from "@apollo/client";
import { EGDSButtonSize, EGDSSecondaryButton } from "@egds/react-core/button";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSText } from "@egds/react-core/text";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { CustomerNotification, CustomerNotificationLocation } from "@shared-ui/customer-notifications";
// src/components/helpers/create-deep-link.ts
var createDeepLink = function(linkUrl, canonicalUrl) {
    try {
        var deepLinkUrl = new URL(linkUrl);
        return !deepLinkUrl.searchParams.has("$canonical_url") || !canonicalUrl ? "".concat(deepLinkUrl, "/") : "".concat(deepLinkUrl).concat(encodeURIComponent(canonicalUrl));
    } catch (error) {
        return void 0;
    }
};
// src/components/mobile-app-download-button-secondary-button/mobile-app-download-button-secondary-button.tsx
var fragment = gql(_templateObject());
var MobileAppDownloadButtonSecondaryButton = function(param) {
    var data = param.data, optionalPageId = param.optionalPageId, bannerAction = param.bannerAction;
    var _bannerAction_resource;
    var analytics = data.analytics, icon = data.icon, primary = data.primary;
    var analyticsTracker = useClickTracker();
    var location = useLocation();
    var triggerRef = React.useRef(null);
    var ref = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(false), 2), showBanner = _React_useState[0], setShowBanner = _React_useState[1];
    var branchLink;
    var handleOutsideClick = function(e) {
        if (ref.current && !ref.current.contains(e.target)) {
            if (showBanner) {
                setShowBanner(false);
            }
        }
    };
    var handleESCKeyPress = function(e) {
        if (e.key === "Escape") {
            if (showBanner) {
                setShowBanner(false);
            }
        }
    };
    React.useEffect(function() {
        document.addEventListener("keydown", handleESCKeyPress);
        document.addEventListener("mousedown", handleOutsideClick);
        return function() {
            document.removeEventListener("keydown", handleESCKeyPress);
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    });
    if (!icon || !analytics) {
        return null;
    }
    if ((bannerAction === null || bannerAction === void 0 ? void 0 : bannerAction.__typename) === "UIBannerLinkAction" && ((_bannerAction_resource = bannerAction.resource) === null || _bannerAction_resource === void 0 ? void 0 : _bannerAction_resource.value)) {
        var canonicalUrl = "".concat(location.pathname).concat(location.search);
        branchLink = createDeepLink(bannerAction.resource.value, canonicalUrl);
    }
    var onClickButton = function() {
        analyticsTracker(analytics.referrerId, analytics.linkName, void 0, []);
        setShowBanner(!showBanner);
    };
    var _icon_title, _ref, _icon_title1, _ref1;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, (bannerAction === null || bannerAction === void 0 ? void 0 : bannerAction.__typename) === "UIBannerLinkAction" && branchLink && /* @__PURE__ */ React.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React.createElement(EGDSSecondaryButton, {
        size: EGDSButtonSize.SMALL,
        tag: "a",
        href: branchLink,
        onClick: onClickButton,
        "aria-label": "".concat((_ref = (_icon_title = icon.title) !== null && _icon_title !== void 0 ? _icon_title : primary) !== null && _ref !== void 0 ? _ref : "")
    }, /* @__PURE__ */ React.createElement(EGDSIcon, {
        id: icon.id,
        name: icon.id
    }), primary && /* @__PURE__ */ React.createElement(EGDSText, {
        whiteSpace: "nowrap",
        "aria-hidden": "true"
    }, primary))), (bannerAction === null || bannerAction === void 0 ? void 0 : bannerAction.__typename) === "UINotificationAction" && /* @__PURE__ */ React.createElement("div", {
        ref: ref
    }, /* @__PURE__ */ React.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React.createElement(EGDSSecondaryButton, {
        size: EGDSButtonSize.SMALL,
        onClick: onClickButton,
        domRef: triggerRef,
        "aria-label": "".concat((_ref1 = (_icon_title1 = icon.title) !== null && _icon_title1 !== void 0 ? _icon_title1 : primary) !== null && _ref1 !== void 0 ? _ref1 : "")
    }, /* @__PURE__ */ React.createElement(EGDSIcon, {
        id: icon.id,
        name: icon.id
    }), primary && /* @__PURE__ */ React.createElement(EGDSText, {
        whiteSpace: "nowrap",
        "aria-hidden": "true"
    }, primary))), showBanner && /* @__PURE__ */ React.createElement(CustomerNotification, {
        inputs: {
            notificationLocation: CustomerNotificationLocation[bannerAction.notificationSlot || CustomerNotificationLocation.IN_MODAL],
            xPageId: optionalPageId
        }
    })));
};
MobileAppDownloadButtonSecondaryButton.fragment = fragment;
MobileAppDownloadButtonSecondaryButton.displayName = "MobileAppDownloadButtonSecondaryButton";
// src/components/mobile-app-download-button/query/mobile-app-download-button-query.tsx
import { gql as gql2 } from "@apollo/client";
var MobileAppDownloadButtonRequestQuery = gql2(_templateObject1(), MobileAppDownloadButtonSecondaryButton.fragment);
// src/components/mobile-app-download-button/mobile-app-download-button.tsx
var __GetMobileAppDownloadButton = MobileAppDownloadButtonRequestQuery;
var MobileAppDownloadButton = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__GetMobileAppDownloadButton, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data) {
        return null;
    }
    var _data_notification = data.notification, _data_notification_mobileAppDownloadButton = _data_notification.mobileAppDownloadButton, button = _data_notification_mobileAppDownloadButton.button, revealAction = _data_notification_mobileAppDownloadButton.revealAction, action = _data_notification_mobileAppDownloadButton.action;
    if (!button || !button.icon || !button.analytics || !revealAction || !revealAction.linkName) {
        return null;
    }
    var pageId = inputs.optionalPageId || "";
    return /* @__PURE__ */ React2.createElement(IntersectionTracker, {
        referrerId: revealAction.referrerId,
        linkName: revealAction.linkName,
        trackOnce: true
    }, /* @__PURE__ */ React2.createElement(Viewport, null, /* @__PURE__ */ React2.createElement(ViewSmall, null, /* @__PURE__ */ React2.createElement(MobileAppDownloadButtonSecondaryButton, {
        data: button,
        optionalPageId: pageId,
        bannerAction: action
    }))));
};
MobileAppDownloadButton.displayName = "sharedui-MobileAppDownloadButton";
export { MobileAppDownloadButton }; /* istanbul ignore next -- @preserve */ 
//# sourceMappingURL=index.js.map